export default "__VITE_ASSET__BsJbGIMj__"